/* Learning Center article shell (canvas 2026-10-14): builds the jump list
   from the body's H2s (four then Show all on a phone, all on desktop, the
   section in view marked) and turns the YouTube iframes pasted into the
   body into posters that play large on the page through the ca-guides.js
   overlay. */
(function () {
  'use strict';
  if (window.__caLearn) return;
  window.__caLearn = true;
  var PLAY = '<span class="ca-species-video__play" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"></path></svg></span>';
  function ytId(src) {
    var m = src.match(/(?:youtube(?:-nocookie)?\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : '';
  }
  document.querySelectorAll('[data-ca-article]').forEach(function (root) {
    var rte = root.querySelector('[data-ca-article-rte]');
    if (!rte) return;

    // Iframes to posters
    rte.querySelectorAll('iframe').forEach(function (frame) {
      var id = ytId(frame.getAttribute('src') || '');
      if (!id) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ca-species-video__player ca-article__video';
      btn.setAttribute('data-ca-guide-video', id);
      btn.setAttribute('data-ca-guide-title', frame.getAttribute('title') || 'Video');
      btn.setAttribute('aria-label', 'Play video: ' + (frame.getAttribute('title') || ''));
      var img = document.createElement('img');
      img.src = 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
      img.width = 480;
      img.height = 360;
      img.alt = '';
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.insertAdjacentHTML('beforeend', PLAY);
      var box = frame.parentElement;
      var target = frame;
      if (box && box !== rte && box.children.length === 1 && /padding-top/.test(box.getAttribute('style') || '')) target = box;
      target.replaceWith(btn);
    });

    // A body never carries its own H1: the shell prints the title. A pasted
    // one that got past the server-side cut goes, with its wrapper when
    // that wrapper is a styled box.
    rte.querySelectorAll('h1').forEach(function (h) {
      var box = h.parentElement;
      if (box && box !== rte && /border-top|background/.test(box.getAttribute('style') || '')) box.remove();
      else h.remove();
    });

    // Jump list
    var toc = root.querySelector('[data-ca-article-toc]');
    var list = root.querySelector('[data-ca-article-toc-list]');
    var more = root.querySelector('[data-ca-article-toc-more]');
    if (!toc || !list) return;
    var h2s = Array.prototype.filter.call(rte.querySelectorAll('h2'), function (h) { return h.textContent.trim().length > 0; });
    if (h2s.length < 2) return;
    var cap = window.matchMedia('(max-width: 768px)').matches ? 4 : 0;
    var links = [];
    h2s.forEach(function (h, i) {
      if (!h.id) h.id = 'ca-section-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      var num = document.createElement('span');
      num.className = 'ca-article__toc-num';
      num.textContent = String(i + 1);
      var label = document.createElement('span');
      label.textContent = h.textContent.trim();
      a.appendChild(num);
      a.appendChild(label);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      if (cap && i >= cap) li.hidden = true;
      list.appendChild(li);
      links.push(a);
    });
    if (cap && h2s.length > cap && more) {
      more.textContent = 'Show all ' + h2s.length + ' sections';
      more.hidden = false;
      more.addEventListener('click', function () {
        list.querySelectorAll('li[hidden]').forEach(function (li) { li.hidden = false; });
        more.hidden = true;
      });
    }
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-80px 0px -70% 0px' });
      h2s.forEach(function (h) { obs.observe(h); });
    }
  });
})();

/* Blog index: a select jumps to the tagged list it names; Show more
   fetches the next page through the Section Rendering API and appends
   its rows. */
(function () {
  'use strict';
  document.querySelectorAll('[data-ca-blog]').forEach(function (root) {
    var rows = root.querySelector('[data-ca-blog-rows]');
    var shown = root.querySelector('[data-ca-blog-shown]');
    var more = root.querySelector('[data-ca-blog-more]');
    var section = root.getAttribute('data-ca-blog-section');
    function count() {
      if (!shown || !rows) return;
      shown.textContent = String(rows.querySelectorAll('[data-ca-blog-row]').length);
    }
    count();
    root.querySelectorAll('[data-ca-blog-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = sel.value;
        if (url) window.location.href = url;
      });
    });
    if (more && rows) {
      more.addEventListener('click', function () {
        var next = more.getAttribute('data-ca-blog-next');
        if (!next || more.classList.contains('is-busy')) return;
        more.classList.add('is-busy');
        var url = next + (next.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(section);
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ca-blog-rows]');
          if (fresh) {
            Array.prototype.slice.call(fresh.children).forEach(function (c) { rows.appendChild(c); });
          }
          var nextBtn = doc.querySelector('[data-ca-blog-more]');
          if (nextBtn && nextBtn.getAttribute('data-ca-blog-next')) {
            more.setAttribute('data-ca-blog-next', nextBtn.getAttribute('data-ca-blog-next'));
          } else {
            more.remove();
          }
          count();
          more.classList.remove('is-busy');
          try { if (window.clarity) window.clarity('event', 'ca_blog_show_more'); } catch (err) {}
        }).catch(function () { more.classList.remove('is-busy'); window.location.href = next; });
      });
    }
  });
})();

/* Videos page: the search and the chips narrow by words in the title
   (Full videos and Shorts split on the duration); the grid shows the cap
   at a time and Show more reveals the next batch of the matches. */
(function () {
  'use strict';
  document.querySelectorAll('[data-ca-videos]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ca-videos-item]'));
    var cap = Number(root.getAttribute('data-ca-videos-cap')) || 12;
    var shownEl = root.querySelector('[data-ca-videos-shown]');
    var totalEl = root.querySelector('[data-ca-videos-total]');
    var more = root.querySelector('[data-ca-videos-more]');
    var empty = root.querySelector('[data-ca-videos-empty]');
    var search = root.querySelector('[data-ca-videos-search]');
    var chipsBox = root.querySelector('[data-ca-videos-chips]');
    var state = { chip: '', q: '', limit: cap };
    function matches(item) {
      var title = item.getAttribute('data-ca-videos-title') || '';
      var isShort = item.getAttribute('data-ca-videos-short') === '1';
      if (state.chip === '__short' && !isShort) return false;
      if (state.chip === '__full' && isShort) return false;
      if (state.chip && state.chip.charAt(0) !== '_') {
        var words = state.chip.split('|');
        var hit = words.some(function (w) { return w && title.indexOf(w.trim()) >= 0; });
        if (!hit) return false;
      }
      if (state.q && title.indexOf(state.q) < 0) return false;
      return true;
    }
    function render() {
      var n = 0, total = 0;
      items.forEach(function (item) {
        var ok = matches(item);
        if (ok) total += 1;
        var show = ok && n < state.limit;
        if (show) n += 1;
        item.hidden = !show;
      });
      if (shownEl) shownEl.textContent = String(n);
      if (totalEl) totalEl.textContent = String(total);
      if (more) more.hidden = n >= total;
      if (empty) empty.hidden = total > 0;
    }
    if (search) {
      search.addEventListener('input', function () {
        state.q = search.value.trim().toLowerCase();
        state.limit = cap;
        render();
      });
    }
    if (chipsBox) {
      chipsBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ca-videos-chip]');
        if (!b) return;
        state.chip = b.getAttribute('data-ca-videos-chip') || '';
        state.limit = cap;
        chipsBox.querySelectorAll('[data-ca-videos-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        render();
        try { if (window.clarity) window.clarity('event', 'ca_videos_filter'); } catch (err) {}
      });
    }
    if (more) {
      more.addEventListener('click', function () { state.limit += cap; render(); });
    }
    render();
  });
})();
